export default "__VITE_ASSET__DVFjAE2b__"